import React, { useContext, useEffect, useState } from "react";
import { Box, TextField, Button } from "@mui/material";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { ProfileCategoryService } from "../../services/ProfileCategoryService";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { otpLogin } from "../../actions/auth";
import { replaceCountryCode } from "../../../utils";
import { StorageConstants } from "../../storage/storageConstants";
import { useMessage } from "../../../base/MessageProvider";
import { Bars } from "react-loader-spinner";
import clsx from "clsx";

/**
 * @author Sarthak Sharma.
 * @since 08-12-2023.
 * @description Login page.
 */

const loginStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "90%",
  bgcolor: "white",
  paddingX: 6,
  paddingY: 3,
  borderRadius: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const LogIn = (): React.ReactElement => {
  const [userData, setUserData] = useState(null);
  const [phone, setPhone] = React.useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const loading = useSelector((state) => state.authReducer?.loading);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alert = useMessage();

  const handleChange = (newPhone) => {
    setPhone(newPhone);
  };

  useEffect(() => {
    const checkAuthentications = async () => {
      setErrorMessage("");
      const token = await localStorage.getItem(StorageConstants.LOGIN_TOKEN);
      if (token) {
        navigate("/admin", { replace: true });
        return;
      }

      // user data save in local
      const username = await localStorage.getItem(StorageConstants.USER_NAME);
      const mobileNo = await localStorage.getItem(
        StorageConstants.MOBILE_NUMBER
      );
      if (mobileNo) {
        setUserData({ username, mobileNo });
        setPhone(`+91${mobileNo}`);
      }
    };
    checkAuthentications();
  }, []);

  const onChangePhone = () => {
    // clear user data from local
    setUserData(null);
    localStorage.clear();
  };

  const onSubmit = async (e) => {
    e?.preventDefault();
    setErrorMessage("");
    if (!matchIsValidTel(phone)) {
      setErrorMessage("Invalid mobile number!!");
      return;
    }
    const mobileNo = replaceCountryCode(phone);
    dispatch(
      otpLogin(
        { mobileNo },
        (loginOtp) => {
          navigate("/admin/otp", { replace: false });
          if (mobileNo === "9311449960")
            alert.showInfo(loginOtp, { timeout: 5000 });
        },
        (error) => {
          setErrorMessage(error?.message ?? "Something went wrong!!");
        }
      )
    );
  };

  return (
    <Box className="h-screen w-screen login-form">
      <form onSubmit={onSubmit} action="#">
        <Box sx={loginStyle}>
          {/* <h1 className="font-['CG-SemiBold'] text-[38px] leading-9 tracking-[0.14em]">STARNEX</h1> */}
          <img
            src={require("../../../assets/images/white-bg-logo.png")}
            className="h-[40px]"
          />
          <div className="w-full my-5">
            <h2 className="w-full text-left font-['CG-Medium'] text-[24px] mb-4">
              Log In
            </h2>
            {userData ? (
              <>
                <h2 className="text-[16px] text-[#6D7175] font-['CG-Regular']">
                  Continue to {userData?.username}
                </h2>
                <div className="flex justify-between my-5">
                  <h2 className="text-[14px] text-[#202223] font-['CG-Regular']">
                    {userData?.mobileNo}
                  </h2>
                  <a
                    onClick={onChangePhone}
                    className="text-[14px] text-[#26805F] font-['CG-Regular'] cursor-pointer hover:underline"
                  >
                    Change number
                  </a>
                </div>
              </>
            ) : (
              <div className="flex flex-col gap-3">
                <span className="text-[12px] text-[#6D7175] font-['CG-Regular']">
                  Mobile Number
                </span>
                <MuiTelInput
                  defaultCountry="IN"
                  disableFormatting
                  disableDropdown
                  forceCallingCode
                  value={phone}
                  onChange={handleChange}
                />
              </div>
            )}
            {errorMessage && (
              <div className="flex my-2">
                <div className="text-[14px] text-red-600">{errorMessage}</div>
              </div>
            )}
            {/* <div className="flex flex-col gap-3">
                            <span className="text-[12px] text-[#6D7175] font-['CG-Regular']">Password</span>
                            <TextField size="small" className="text-[14px]" />
                        </div> */}
            <button
              disabled={loading}
              onClick={onSubmit}
              className={clsx(
                "bg-[#26805F] rounded-[4px] active:bg-gray-500 w-full h-[43px] my-5 text-[14px] text-[#F2F2F2] font-['Poppins-Medium']",
                { "bg-opacity-70": loading }
              )}
            >
              <div className="w-full flex gap-3 justify-center">
                Log In
                <Bars
                  height="20"
                  width={"20"}
                  color="#FFFFFF"
                  ariaLabel="bars-loading"
                  visible={loading}
                />
              </div>
            </button>
            {/* <button className="flex justify-center items-center gap-3 rounded-[4px] active:bg-gray-500 w-full h-[43px] my-4 text-[14px] font-['Poppins-Medium'] border-[1px] border-[grey]">
                            <img className="w-5 h-5" src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-google-icon-logo-png-transparent-svg-vector-bie-supply-14.png" />
                            Log in with Google
                        </button> */}
          </div>
        </Box>
      </form>
    </Box>
  );
};

export default LogIn;
